import QuartzDashboardView from "src/sections/dashboards/platforms/quartz/quartz-dashboard-view";

const QuartzMainDashboardPage = () => <QuartzDashboardView type="main" />;

export default QuartzMainDashboardPage;
